export const environment = {
    production: false,
    baseUrl: 'http://localhost:4200',
    apiUrl: import.meta.env["NG_APP_API"],
    googleMapsApiKey: import.meta.env["NG_APP_MAPS_KEY"],
    version: 'v1.2.1'
};
